import { MutationTree } from 'vuex'
import { ProfileState } from './types'

export const mutations: MutationTree<ProfileState> = {
  storeUser: (_, { user }) => window.sessionStorage.setItem('user', JSON.stringify(user)),
  clearUser: () => window.sessionStorage.removeItem('user'),
  setUser: (state, { user }) => state.user = user,
  loginSuccess: (state, { user }) => {
    state.error = false
    state.user = user
  },
  loginError: state => {
    state.error = true
    state.user = undefined
  },
  logout: state => {
    state.error = false
    state.user = undefined
  },
}
